<template>
  <div class="w-full flex gap-2" vs-align="center" :class="!!widthClass ? widthClass : 'xl:w-auto'">
    <div v-if="!!label" class="title" :class="size">{{ label }}</div>
    <div class="flex-1 flex items-center gap-3">
      <vs-radio v-for="item in list" :key="item" :vs-name="id" :vs-value="item" v-model="selectData">{{ item }}</vs-radio>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchNavItemRadio",
  props: {
    id: String,
    label: {
      type: String,
      default: "",
    },
    value: String,
    list: Array,
    size: {
      type: String,
      default: "normal",
    },
    readonly: Boolean,
    widthClass: String,
  },
  watch: {
    value: {
      handler(value) {
        this.selectData = value;
      },
    },
    selectData: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      selectData: this.value,
    };
  },
};
</script>

<style lang="scss" scoped>
.title {

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;

  &.small {
    width: auto !important;
  }
}

@media (max-width: 1200px) {
  .title {
    width: 114px !important;
  }
}
</style>
